import React from "react";
import { Card, CardDeck } from "react-bootstrap";
import "./index.css";
import Webhooks from "./Webhooks";
import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";

export default function Integracoes() {
  return (
    <div className="integracao_pagina">
      <DommusBarraTitulo>
        <ItemBarraTitulo classe="">Integrações</ItemBarraTitulo>
      </DommusBarraTitulo>
      <CardDeck>
        <Card className="p-0 mx-3 cardIntegracao col-12 col-lg-4">
          <Card.Header>Webhooks</Card.Header>
          <Webhooks/>
        </Card>
      </CardDeck>
    </div>
  );
}
